module.exports = __webpack_public_path__ + "img/c48f8a8.jpg";